export function getNewFormattedDate() {
  const now = new Date();

  // Obtener la diferencia en horas entre la zona horaria local (Argentina) y UTC
  const offset = -3; // Argentina está generalmente en UTC-3
  const localDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

  // Formatear la fecha en formato ISO 8601 con el offset `+00:00`
  const formattedDate = localDate.toISOString().replace("Z", "+00:00");
  return formattedDate;
}

export function getNewDateArgentina(daysToAdd = 0) {
  const now = new Date();

  // Obtener la diferencia en horas entre la zona horaria local (Argentina) y UTC
  const offset = -3; // Argentina está generalmente en UTC-3
  const localDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

  // sumar días si corresponde
  localDate.setDate(localDate.getDate() + daysToAdd);

  // Poner la hora en 00:00:00.000
  localDate.setUTCHours(0, 0, 0, 0);

  // Devolver en formato ISO con "+00:00"
  const isoString = localDate.toISOString().replace("Z", "+00:00");
  return isoString;
}